import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../../components/layout/SiteShell";
import ContentPageLayout from "../../components/content/ContentPageLayout";
import SEO from "../../components/seo/SEO";
import WellnessDisclaimer from "../../components/content/WellnessDisclaimer";

const WAITLIST_MAIL = "mailto:info@mossmatrix.com?subject=Skin%20range%20waitlist";

export default function ComingSoonSkinRangePage() {
  const path = "/coming-soon/skin-range";
  return (
    <SiteShell>
      <SEO
        title="Skin range | Coming soon | MossMatrix"
        description="MossMatrix Skin Rituals coming soon: a rich mango butter and sea moss body blend in a 100ml aluminium jar. Skin-softening, nourishing feel, cosmetic-style copy only."
        path={path}
      />
      {/* Before selling: UK cosmetic compliance review, labelling, stability/safety checks, product notification where required. */}
      <ContentPageLayout
        eyebrow="Coming soon"
        title="MossMatrix Skin Rituals"
        subtitle="Starting with a rich mango butter and sea moss body blend in a 100ml aluminium jar: handmade, longer shelf life than fresh gel, and crafted for everyday skin rituals."
      >
        <div className="max-w-3xl space-y-6 text-sm text-botanical/85 leading-relaxed mb-10">
          <p>
            This range is designed for a <strong className="text-forest font-medium">nourishing feel</strong> and{" "}
            <strong className="text-forest font-medium">skin-softening</strong> texture. A{" "}
            <strong className="text-forest font-medium">rich body butter</strong> style product for{" "}
            <strong className="text-forest font-medium">dry-feeling skin</strong>, not a fresh daily gel. We’re aiming for a stable, premium
            format with a target of around <strong className="text-forest font-medium">12 months</strong> shelf life in the aluminium jar. Final
            dates will follow lab review.
          </p>
          <p className="text-xs text-botanical/70">
            We won’t claim this treats eczema, acne, psoriasis, inflammation, scars, or any medical condition. It is a cosmetic-style body
            product with honest, gentle language only.
          </p>
        </div>

        <div className="rounded-3xl border border-cream bg-offwhite p-8 text-center max-w-lg mx-auto mb-12">
          <p className="font-serif text-xl text-forest">Join the skin range waitlist</p>
          <p className="mt-2 text-sm text-botanical/75">We’ll email you when the first batch is ready. No spam, just launch news.</p>
          <a
            href={WAITLIST_MAIL}
            className="mt-6 inline-flex rounded-full bg-forest text-cream px-8 py-3.5 text-sm font-medium hover:bg-botanical transition"
          >
            Email the waitlist
          </a>
        </div>

        <WellnessDisclaimer className="max-w-3xl mx-auto" />

        <p className="text-center text-sm text-botanical/70 mt-10">
          <Link to="/shop" className="underline hover:text-forest">
            Shop gel
          </Link>
          {" · "}
          <Link to="/coming-soon/herbal-pantry" className="underline hover:text-forest">
            Herbal Pantry (coming soon)
          </Link>
        </p>
      </ContentPageLayout>
    </SiteShell>
  );
}
